import { Warning24Filled, Warning24Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const IncidentApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "IncApp" */ "./IncidentApp");
    return { default: namedExport.IncidentApp };
});

export const Incidents: TeamAppConfig = {
    title: "Incidents",
    regularIcon: Warning24Regular,
    filledIcon: Warning24Filled,
    path: "/incidents",
    description:
        "Incidents app provides a list of all the incidents, allowing users to filter and sort based on their needs." +
        " Users can also view incidents more in-depth with our details page.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["xam", "errors", "summary", "availability", "dag", "trend", "network", "cafe", "cafe heatmap"],
    app: IncidentApp
};
